export const show = (metadata) => {
  return undefined === metadata?.docType || metadata?.docType === null;
};
